import { render, staticRenderFns } from "./region-village-tree.vue?vue&type=template&id=ad8ec7dc&scoped=true&"
import script from "./region-village-tree.vue?vue&type=script&lang=js&"
export * from "./region-village-tree.vue?vue&type=script&lang=js&"
import style0 from "./region-village-tree.vue?vue&type=style&index=0&id=ad8ec7dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8ec7dc",
  null
  
)

export default component.exports